<template>
  <div class="mt-20">
    <div class="text-right font-14">
      ВСЕГО В СПИСКЕ ЮЕЗРОВ: <b class="font-14">{{ total }}</b>
    </div>
    <div class="text-right font-14">
      ОСТАНОВИЛИ БОТА ВО ВРЕМЯ ПОСЛЕДНЕЙ РАССЫЛКИ: <b class="font-14">{{ bannedInLastMailing }}</b>
    </div>
    <div class="text-right font-14">
      АКТИВНЫХ ПОЛЬЗОВАТЕЛЕЙ НА МОМЕНТ ПОСЛЕДНЕЙ РАССЫЛКИ: <b class="font-14">{{ activeCounter }}</b>
    </div>
    <div class="text-right font-14">
      ДАТА ПОСЛЕДНЕЙ РАССЫЛКИ: <b class="font-14">{{ lastMailingDate }}</b>
    </div>
  </div>
</template>

<script>
import {ApiService} from "@/api";

export default {
  name: 'UserAmount',
  data: () => ({
    bannedInLastMailing: '',
    activeCounter: '',
    total: '',
    lastMailingDate: '',
  }),
  props: {
    botName: {
      type: String,
      required: true
    }
  },

  created () {
    ApiService.getUserAmountForBot(this.botName)
        .then(res => {
          if (res.error) {
            throw new Error(res.msg)
          }
          this.activeCounter = res.current
          this.bannedInLastMailing = res.bannedInLastMailing
          this.total = res.total
          this.lastMailingDate = res.lastMailingDate
        })
        .catch((err) => {
          console.log(err)
          alert(`Не удалось получить данные о количестве пользователей бота ${this.botName}`)
        })
  }
}
</script>

<style>

</style>
